<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <dropdown :class="['mr-2']" v-model="xAlign" :items="xAlignments" width="100px" :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" /><!--
          --><dropdown :class="['mr-2']" v-model="yAlign" :items="yAlignments" width="100px" :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <table-layout :class="['test-table', 'text-xs']">
          <row v-for="row in 5" :key="row">
            <cell v-for="cell in 5" :key="cell" :y-align="yAlign[0]" :x-align="xAlign[0]" :class="['p-2']">
              <code>{{ row }}/{{ cell }}</code>
            </cell>
          </row>
        </table-layout>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageTableLayout',
  mixins: [
    methods
  ],
  data () {
    return {
      yAlign: ['middle'],
      xAlign: ['center'],
      xAlignments: ['left', 'center', 'right'].map(value => {
        return {
          value,
          text: this.firstLetterCapital(value)
        }
      }),
      yAlignments: ['top', 'middle', 'bottom'].map(value => {
        return {
          value,
          text: this.firstLetterCapital(value)
        }
      })
    }
  }
}
</script>
<style>
.test-table .bcq-table-layout-cell
{
  border: solid 1px var(--semi-transparent-dark);
  height: 48px;
}

.bcq-ui-theme-dark .test-table .bcq-table-layout-cell
{
  border: solid 1px var(--semi-transparent-light);
}
</style>



// WEBPACK FOOTER //
// src/pages/content/table-layout.vue